import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { BarChartIcon } from '../components/ui/icons';
import { StatisticsOverview } from '../components/admin/StatisticsOverview';
import { UserGrowthChart } from '../components/admin/UserGrowthChart';
import { SurveyTrendChart } from '../components/admin/SurveyTrendChart';
import { RecentActivityFeed } from '../components/admin/RecentActivityFeed';
import { PieceIssuanceChart } from '../components/admin/PieceIssuanceChart';
import { ActivityTrendChart } from '../components/admin/ActivityTrendChart';
import { adApi } from '../api/ad.api';

const AdminMonitorDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* 헤더 */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-blue-500 rounded-xl flex items-center justify-center shadow-lg">
                <BarChartIcon className="w-5 h-5 text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">모니터링 대시보드</h1>
                <p className="text-gray-600 text-sm">플랫폼 현황을 한눈에 확인하세요.</p>
              </div>
            </div>
            <Button
              variant="outline"
              onClick={() => navigate('/admin/dashboard')}
              className="flex items-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="hidden sm:inline">관리자로</span>
            </Button>
          </div>
        </div>

        {/* 대시보드 내용 */}
        <div className="space-y-6">
          <StatisticsOverview />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <UserGrowthChart />
            <SurveyTrendChart />
          </div>
          <PieceIssuanceChart />
          <ActivityTrendChart title="출석체크 추이" rewardType="ATTENDANCE" color="#10B981" />
          <ActivityTrendChart title="투표 추이" rewardType="VOTE" color="#3B82F6" />
          <ActivityTrendChart
            title="광고 시청 추이"
            color="#8B5CF6"
            apiFn={(period) => adApi.getAdWatchTrend(period)}
          />
          <RecentActivityFeed />
        </div>
      </div>
    </div>
  );
};

export default AdminMonitorDashboard;
